export const experienceOptions = [
  { name: "Intern", value: "intern" },
  { name: "Individual Contributor", value: "individual-contributor" },
];
